// src/utils/logger.ts
// Utilitaire de logging conditionnel — actif uniquement en développement (Vite)
 
const isDev = import.meta.env.DEV;
 
type LogFn = (...args: unknown[]) => void;
 
const createLogFn = (prefix: string): LogFn => {
  return (...args: unknown[]) => {
    if (isDev) {
      console.log(`[${prefix}]`, ...args);
    }
  };
};
 
export const logger = {
  fcm: createLogFn("FCM"),
  email: createLogFn("Email"),
  auth: createLogFn("Auth"),
  push: createLogFn("Push"),
  storage: createLogFn("Storage"),
  db: createLogFn("DB"),
  // Ajoute d'autres catégories au besoin :
  // stripe: createLogFn("Stripe"),
  // cron: createLogFn("Cron"),
};